<template>
  <div
    class="group flex items-center w-full transition duration-100 ease-in-out border rounded focus-within:ring-2 focus-within:ring-blue-500 focus-within:outline-none focus-within:ring-opacity-50"
    :class="[classes, { 'border-0 ring-1 ring-inset ring-red-500 dark:ring-red-400 focus:ring-red-500 dark:focus:ring-red-400': error }]"
  >
    <label class="flex items-center w-full h-full">
      <slot name="leading" />
      <input
        v-model="_value"
        class="appearance-none h-full bg-transparent w-full outline-none placeholder-primary/[0.8]"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :autocomplete="autocomplete"
        v-on="handlers"
      >
    </label>

    <slot name="trailing" />
  </div>
</template>

<script setup lang="ts">
import { useInput } from '~/composables/input';
import type { Variants, Sizes } from '~/composables/input';

defineOptions({
  name: 'BTextInput'
});

const props = defineProps<{
  modelValue: string | number;
  id?: string;
  type?: string;
  placeholder?: string;
  autocomplete?: string;
  variant?: keyof Variants;
  size?: keyof Sizes;
  flat?: boolean;
  disabled?: boolean;
  error?: boolean;
}>();

const emit = defineEmits(['update:modelValue', 'blur', 'focus', 'keyup', 'keydown']);

const _value = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
  }
});

const { classes, handlers } = useInput(
  {
    variant: props.variant || 'base',
    size: props.size || 'md',
    flat: props.flat || false,
    disabled: props.disabled || false,
  },
  emit as (event: string, ...args: any[]) => void
);

// import Input from '@/mixins/input.js'

// export default {
//   name: 'BTextInput',
//   mixins: [Input],
//   props: {
//     modelValue: {
//       type: [String, Number],
//       default: ''
//     },
//     id: {
//       type: String,
//       default: null
//     },
//     type: {
//       type: String,
//       default: 'text'
//     },
//     placeholder: {
//       type: String,
//       default: null
//     },
//     autocomplete: {
//       type: String,
//       default: null
//     }
//   },
//   computed: {
//     _value: {
//       get () {
//         return this.modelValue
//       },
//       set (value) {
//         this.$emit('input', value)
//         this.$emit('change', value)
//         this.$emit('update:modelValue', value)
//       }
//     }
//   }
// }
</script>
